export const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    seq: "cat-shoes-v2-01",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20white%20leather%20sneakers%20with%20green%20accents%20on%20light%20beige%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20high%20detail%2C%20elegant%20shadow%20play&width=400&height=400&seq=cat-shoes-v2-01&orientation=squarish",
  },
  {
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-shirt-line",
    seq: "cat-hoodies-v2-02",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20heathered%20gray%20oversized%20hoodie%20neatly%20folded%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20catalog%20style%2C%20clean%20aesthetic&width=400&height=400&seq=cat-hoodies-v2-02&orientation=squarish",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-line",
    seq: "cat-tshirts-v2-03",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20black%20heavyweight%20cotton%20tshirt%20laid%20flat%20on%20light%20oak%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20subtle%20fabric%20texture%20visible&width=400&height=400&seq=cat-tshirts-v2-03&orientation=squarish",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-t-shirt-2-line",
    seq: "cat-jackets-v2-04",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20khaki%20bomber%20jacket%20on%20wooden%20hanger%20against%20warm%20beige%20wall%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20clean%20composition%2C%20visible%20details&width=400&height=400&seq=cat-jackets-v2-04&orientation=squarish",
  },
  {
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-pantone-line",
    seq: "cat-pants-v2-05",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20tailored%20beige%20chino%20pants%20neatly%20folded%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20visible%20fabric%20texture&width=400&height=400&seq=cat-pants-v2-05&orientation=squarish",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-billiards-line",
    seq: "cat-headwear-v2-06",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20navy%20baseball%20cap%20with%20subtle%20embroidery%20on%20light%20stone%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20clean%20aesthetic%2C%20side%20angle&width=400&height=400&seq=cat-headwear-v2-06&orientation=squarish",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    seq: "cat-sets-v2-07",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20matching%20sage%20green%20hoodie%20and%20jogger%20set%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20coordinated%20outfit%20flat%20lay&width=400&height=400&seq=cat-sets-v2-07&orientation=squarish",
  },
  {
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-checkbox-blank-line",
    seq: "cat-underwear-v2-08",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20soft%20organic%20cotton%20boxer%20briefs%20neatly%20folded%20on%20light%20beige%20linen%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20subtle%20texture&width=400&height=400&seq=cat-underwear-v2-08&orientation=squarish",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-medal-line",
    seq: "cat-jersey-v2-09",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20striped%20soccer%20jersey%20laid%20flat%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20vibrant%20colors%20pop%20against%20neutral%20background&width=400&height=400&seq=cat-jersey-v2-09&orientation=squarish",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
    seq: "cat-accessories-v2-10",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20tortoiseshell%20sunglasses%20and%20minimalist%20silver%20bracelet%20on%20light%20marble%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20elegant%20composition&width=400&height=400&seq=cat-accessories-v2-10&orientation=squarish",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    seq: "cat-bags-v2-11",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20cognac%20leather%20crossbody%20bag%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20visible%20stitching%20detail%2C%20elegant&width=400&height=400&seq=cat-bags-v2-11&orientation=squarish",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
    seq: "cat-belts-v2-12",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20braided%20brown%20leather%20belt%20coiled%20on%20light%20stone%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20visible%20brass%20buckle%2C%20clean%20composition&width=400&height=400&seq=cat-belts-v2-12&orientation=squarish",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    seq: "cat-perfumes-v2-13",
    image: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20an%20amber%20glass%20perfume%20bottle%20with%20minimal%20label%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20elegant%20shadow%2C%20golden%20accents&width=400&height=400&seq=cat-perfumes-v2-13&orientation=squarish",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
    seq: "cat-other-v2-14",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20assorted%20lifestyle%20items%20including%20candle%20notebook%20and%20pen%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20style%2C%20harmonious%20arrangement&width=400&height=400&seq=cat-other-v2-14&orientation=squarish",
  },
];

export const comparisonPlatforms = [
  {
    name: "Hipobuy Spreadsheet",
    bestFor: "Fashion & lifestyle product discovery",
    rating: "★★★★★",
    highlight: true,
  },
  {
    name: "Kakobuy Spreadsheet",
    bestFor: "Budget-conscious shopping research",
    rating: "★★★★☆",
    highlight: false,
  },
  {
    name: "CSSBuy Spreadsheet",
    bestFor: "Experienced agent shoppers",
    rating: "★★★★☆",
    highlight: false,
  },
  {
    name: "Superbuy Spreadsheet",
    bestFor: "Global product sourcing",
    rating: "★★★★☆",
    highlight: false,
  },
  {
    name: "Oopbuy Spreadsheet",
    bestFor: "New buyer friendly collections",
    rating: "★★★☆☆",
    highlight: false,
  },
];